<button type="button" class="filter-sub-option cfa-plain-button" [ngClass]="{'filter-sub-option__chip-selected' : selected}" (click)="subOptionToggled.emit(name)" [attr.aria-pressed]="selected">
  <div fxLayout="row" fxLayoutAlign="start center">
    <div fxFlex="90" fxLayout="column">
      <div class="filter-sub-option__text" [attr.data-testid]="name + '-sub-name'">{{name}}</div>
      @if (subtext) {
        <div class="filter-sub-option__subtext">{{subtext}}</div>
      }
    </div>
    <div fxFlex="10" fxLayout="column" fxLayoutAlign="end center">
      @if (image) {
        <img class="filter-sub-option__image" alt="" src="{{image}}">
      }
    </div>
  </div>
</button>
